export interface SelectDetails {
  selectedIds: string[];
}

export type SelectionEvent = CustomEvent<SelectDetails>;

export const isSelectionEvent = (event: Event): event is SelectionEvent => {
  // @ts-ignore
  return Array.isArray(event.detail?.selectedIds);
};
